var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"name":_vm.name,"description":_vm.description}}),_c('router-view'),_c('Footer',{attrs:{"linkUrl":_vm.linkUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }